import { Record } from '../../editor/record.types';

const EmptyTaskObject = (formId: string, version: number) => ({
  status: 'Open',
  version,
  created_location: null,
  updated_location: null,
  form_values: {},
  form_id: formId,
  latitude: null,
  longitude: null,
  altitude: null,
  speed: null,
  course: null,
  horizontal_accuracy: null,
  vertical_accuracy: null,
}) as unknown as Record<any>;

export default EmptyTaskObject;
